module.exports = __webpack_public_path__ + "static/media/Man.e5c4c52b.svg";